import originala_prozo from './originala_prozo';
import originala_poezio from './originala_poezio';
import tradukita_prozo from './tradukita_prozo';
import tradukitaj_kantoj from './tradukitaj_kantoj';
import tradukita_poezio from './tradukita_poezio';
import recenzoj from './recenzoj';
import teatraĵoj from './teatraĵoj';
import eseoj from './eseoj';

import rus_recenzoj from './ruslingvaĵoj/recenzoj';
import rus_rezonadoj from './ruslingvaĵoj/rezonadoj';
import rus_rakontoj from './ruslingvaĵoj/rakontoj';
import rus_tradukoj from './ruslingvaĵoj/tradukoj';
import rus_teatraĵoj from './ruslingvaĵoj/teatraĵoj';
import rus_rimaĵoj from './ruslingvaĵoj/rimaĵoj';
import rus_formoj_malgrandaj from './ruslingvaĵoj/formoj_malgrandaj';

const data = {
  categoryList: [
    {value: "/originala-prozo", label: "Originala prozo"},
    {value: "/originala-poezio", label: "Originala poezio"},
    {value: "/tradukita-prozo", label: "Tradukita prozo"},
    {value: "/tradukita-poezio", label: "Tradukita poezio"},
    {value: "/tradukitaj-kantoj", label: "Tradukitaj kantoj"},
    {value: "/eseoj", label: "Eseoj"},
    {value: "/recenzoj", label: "Recenzoj"},
    {value: "/teatraĵoj", label: "Teatraĵoj"},
    {value: "/ruslingvaĵoj", label: "Ruslingvaĵoj", children: [
      {value: "/ruslingvaĵoj/recenzoj", label: "Recenzoj"},
      {value: "/ruslingvaĵoj/rezonadoj", label: "Rezonadoj"},
      {value: "/ruslingvaĵoj/rakontoj", label: "Rakontoj"},
      {value: "/ruslingvaĵoj/rimaĵoj", label: "Rimaĵoj"},
      {value: "/ruslingvaĵoj/tradukoj", label: "Tradukoj"},
      {value: "/ruslingvaĵoj/teatraĵoj", label: "Teatraĵoj"},
      {value: "/ruslingvaĵoj/formoj_malgrandaj", label: "Formoj malgrandaj"}
    ]},
    {value: "/about", label: "Pri la retejo"},
  ],
  itemsList: new Map()
}

data.itemsList.set('originala-prozo', originala_prozo);
data.itemsList.set('originala-poezio', originala_poezio);
data.itemsList.set('tradukitaj-kantoj', tradukitaj_kantoj);

data.itemsList.set('tradukita-poezio', tradukita_poezio);
data.itemsList.set('tradukita-prozo', tradukita_prozo);
data.itemsList.set('eseoj', eseoj);
data.itemsList.set('recenzoj', recenzoj);
data.itemsList.set('teatraĵoj', teatraĵoj);

data.itemsList.set('ruslingvaĵoj/recenzoj', rus_recenzoj);
data.itemsList.set('ruslingvaĵoj/rezonadoj', rus_rezonadoj);
data.itemsList.set('ruslingvaĵoj/rakontoj', rus_rakontoj);
data.itemsList.set('ruslingvaĵoj/tradukoj', rus_tradukoj);
data.itemsList.set('ruslingvaĵoj/teatraĵoj', rus_teatraĵoj);

data.itemsList.set('ruslingvaĵoj/rimaĵoj', rus_rimaĵoj);
data.itemsList.set('ruslingvaĵoj/formoj_malgrandaj', rus_formoj_malgrandaj);




export default data;